import { lazy } from 'react';
import { Outlet, useRoutes } from 'react-router-dom';
import DashboardLayout from '../layouts/dashboard';
import LoginPage from '../pages/login/page/login.page';
import RolePage from '../pages/role/page/role.page';
import PermissionPage from '../pages/permission/page/permission.page';
import PositionCategory from '../pages/positionCategory/page/position.category';
import DocumentTypePage from '../pages/documentType/page/document.type.page';
import DestinationProvincePage from '../pages/destination/page/destination.province.page';
import DestinationMinistryPage from '../pages/destination/page/destination.ministry.page';
import DepartmentPage from '../pages/department/page/department.page';
import ClientPage from '../pages/client/page/client-page';

// ----------------------------------------------------------------------
export const HomePage = lazy(() => import('../pages/home/page/home.page'));
export const DocumentsPage = lazy(() => import('../pages/documents/page/documents.page'));
export const UserPage = lazy(() => import('../pages/user/page/user.page'));
export const SettingPage = lazy(() => import('../pages/setting/page/setting.page'));
export const SpecialPointPage = lazy(() => import('../pages/specialPoint/page/specialpoint.page'));
export const PositionPage = lazy(() => import('../pages/position/page/position.page'));
export const NotificationPage = lazy(() => import('../pages/notification/page/notification.page'));
export const DestinationPage = lazy(
  () => import('../pages/destination/page/destination.province.page')
);
export const NotificationListPage = lazy(
  () => import('../pages/notificationList/page/notificationlist.page')
);
export const CacheManagementPage = lazy(
  () => import('../pages/cacheManagement/page/cache-management.page')
);
export const AppVersionPage = lazy(() => import('../pages/appVersion/page/app-version.page'));
// ----------------------------------------------------------------------
// import NotificationListController from '../pages/notificationList/controllers/notificationlist.controller';
// import HomeController from '../pages/home/controllers/home.controller';
// import DocumentsController from '../pages/documents/controllers/documents.controller';
// import FirebaseController from '../firebase/firebase-controller';
// import ProtectedRoute from './protected-route';
import UnauthorizedPage from './unauthorized-route';
import { routesName } from './data/route-name';
const Router = () => {
  // const home = HomeController();
  // const doc = DocumentsController();
  // const fcm = FirebaseController();
  // const notList = NotificationListController();

  // useEffect(() => {
  //   fcm.initFirebase();
  // }, []);

  // fcm.receiveNotification(() => {
  //   doc.handleGetData(true, doc?.params ?? undefined);
  //   home.getClient();
  //   notList.notificationListGetData(true, null);
  // });

  const routes = useRoutes([
    {
      element: (
        <DashboardLayout>
          <Outlet />
        </DashboardLayout>
      ),
      children: [
        { element: <HomePage />, index: true },
        { path: routesName.document, element: <DocumentsPage /> },
        {
          path: routesName.user,
          element: <UserPage />,
        },
        {
          path: routesName.client,
          element: <ClientPage />,
        },
        {
          path: routesName.settingDestinationMinistry,
          element: <DestinationMinistryPage />,
        },
        {
          path: routesName.settingDestinationProvince,
          element: <DestinationProvincePage />,
        },
        {
          path: routesName.settingDestinationDepartment,
          element: <DepartmentPage />,
        },
        {
          path: routesName.settingPositionAll,
          element: <PositionPage />,
        },
        {
          path: routesName.settingsPositionCategory,
          element: <PositionCategory />,
        },
        {
          path: routesName.settingsDocumentType,
          element: <DocumentTypePage />,
        },
        {
          path: routesName.settingsRole,
          element: <RolePage />,
        },
        {
          path: routesName.settingsPermission,
          element: <PermissionPage />,
        },
        {
          path: routesName.notification_list,
          element: <NotificationListPage />,
        },
        {
          path: routesName.cache_management,
          element: <CacheManagementPage />,
        },
        {
          path: routesName.settings_app_version,
          element: <AppVersionPage />,
        },
        { path: routesName.unauthorized, element: <UnauthorizedPage /> },
      ],
    },
    {
      path: routesName.login,
      element: <LoginPage />,
    },
  ]);

  return routes;
};

export default Router;
